<template>
  <div class="lateness">
    <div class="lateness-header">
      <c-input
        class="lateness-header-posts"
        type="select"
        placeholder="Должности"
        :multiple="true"
        :items="postsLocalItems"
        v-model="postLocalValues"
      />
      <c-switcher
        type="group"
        class="lateness-header-posts-mobile"
        :items="[
           { icon: 'operator', value: 'operator' },
           { icon: 'administrator', value: 'administrator' },
           { icon: 'sushi', value: 'suhi' },
           { icon: 'pizza', value: 'pizzamaker' },
           { icon: 'hot', value: 'hot' },
           { icon: 'driver', value: 'driver' },
        ]"
        v-model="latenessLocalValueMobile" 
      />
      <c-switcher
        class="lateness-header-posts-tablet"
        type="group"
        :items="[
           { label: 'Операторы', value: 'operator' },
           { label: 'Администраторы', value: 'administrator' },
           { label: 'Сушисты', value: 'suhi' },
           { label: 'Пиццемейкеры', value: 'pizzamaker' },
           { label: 'Горячий цех', value: 'hot' },
           { label: 'Водители', value: 'driver' },
        ]"
        v-model="latenessLocalValueTablet"
      />
      <c-input
        class="lateness-header-lateness"
        type="select"
        placeholder="Степень опоздания"
        :clearable="true"
        :items="latenessLocalItems"
        v-model="latenessLocalValue"
      />
    </div>
    <c-data-table-create-calculations-tabs
      class="lateness-table"
      v-if="!dataIsLoading"
      :class="{ 'lateness-table-layout-fixed': postLocalValues.length === 1}"
      ref="table"
      :levels="2"
      :disabledColumns="[]"
      :data="tableData"
      :calcData="data"
      :can-edit="canEdit"
    />
    <c-loader
      class="lateness-loader"
      v-if="dataIsLoading"
      label="Данные загружаются"
      :active="dataIsLoading"
      height="300"/>
    <div class="lateness-buttons-row" v-if="canEdit || canClose || isClosed">
      <c-button
        v-if="canClose"
        size="large"
        class="lateness-toggle-closed"
        :class="{ 'lateness-toggle-closed--active': !isClosed }"
        :disabled="isTogglingClosed"
        :label="isClosed ? 'Открыть расчёт' : 'Закрыть расчёт'"
        :color="isClosed ? 'primary' : undefined"
        @click="$emit('toggleClosed')"
      />
      <span
        v-if="isClosed"
        class="lateness-closed-badge"
      >Расчёт закрыт</span>
      <div class="lateness-buttons" v-if="canEdit">
        <c-button
          label="Отменить"
          color="white"
          class="lateness-buttons-cancel"
        />
        <c-button
          label="Сохранить"
          color="primary"
          class="lateness-buttons-save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/loader"
import DataTableCreateCalculationTabs from "@/pages/calculations/create/additions/data-table-create-calculation-tabs"
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import Button from "@/components/controls2/Button"
import {mapGetters} from "vuex";

export default {
  name: "new-calculation-lateness",
  props: ['data', 'canEdit', 'isClosed', 'canClose', 'isTogglingClosed'],
  components: {
    'c-input': Input,
    'c-button': Button,
    'c-switcher': Switcher,
    'c-loader': Loader,
    'c-data-table-create-calculations-tabs': DataTableCreateCalculationTabs
  },
  computed: {
    ...mapGetters('calculations', [
      'getTableLatenessCreateCalculation'
    ]),
  },

  data () {
    return {
      dataIsLoading: true,
      postLocalValues: [],
      postsLocalItems: [
        { label: 'Оператор', value: 'operator' },
        { label: 'Администратор филиала', value: 'administrator' },
        { label: 'Повар-сушист', value: 'suhi' },
        { label: 'Повар-пиццемейкер', value: 'pizzamaker' },
        { label: 'Горячий цех', value: 'hot' },
        { label: 'Водитель', value: 'driver' },
      ],
      latenessLocalValue: null,
      latenessLocalValueMobile: null,
      latenessLocalValueTablet: null,
      latenessLocalItems: [
        { label: 'Низкая', value: 'less_five' },
        { label: 'Средняя', value: 'five_to_ten' },
        { label: 'Высокая', value: 'more_ten' },
      ],
      tableData: {
        type: 'new-calculation-lateness',
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 2,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
      },
    }
  },

  mounted() {
    this.tableData.columns = this.getTableLatenessCreateCalculation.columns
    this.tableData.records = this.calculateRecords(this.getTableLatenessCreateCalculation.records)
  },

  computed: {
    ...mapGetters("calculations", ["getTableLatenessCreateCalculation"]),
  },

  watch: {
    data(value) {
      //console.log(value.calc);
      value.calc.delayed.posts.map((post) => {
        let post_code = post.post_code;
        if (post_code=="Call-centr") post_code="operator";
        // Replace column lateness labels
        let a = this.tableData.columns.findIndex((col) => col.id === 'less_five_' + post_code)
        if (a !== -1) {
          this.tableData.columns[a].label = '<' + post.params[0]
        }
        let b = this.tableData.columns.findIndex((col) => col.id === 'five_to_ten_' + post_code)
        if (b !== -1) {
          this.tableData.columns[b].label = post.params[0] + '-' + post.params[2]
        }
        let c = this.tableData.columns.findIndex((col) => col.id === 'more_ten_' + post_code)
        if (c !== -1) {
          this.tableData.columns[c].label = '>' + post.params[2]
        }

        post.rows.map((row, rowIndex) => {
          this.tableData.records.map((record, recordIndex) => {
            if (!row.values.length) row.values = [0,0,0];
            if (rowIndex === recordIndex) {
              record['corf_' + post_code].value = (row.korf === 0) ? '' : row.korf.toFixed(1)
              record['load_' + post_code].value = (row.kload === 0) ? '' : row.kload.toFixed(1)
              record['employees_' + post_code].value = row.count_workers
              record['less_five_' + post_code].value = (row.values[0] === 0) ? '' : row.values[0]
              record['five_to_ten_' + post_code].value = (row.values[1] === 0) ? '' : row.values[1]
              record['more_ten_' + post_code].value = (row.values[2] === 0) ? '' : row.values[2]
              record['total_' + post_code].value = (row.values.length && (row.values[0] + row.values[1] + row.values[2]) === 0) ? '' : (row.values[0] + row.values[1] + row.values[2]);
             // console.log(row.values.length, row.values, record['total_' + post_code].value);
              if (record['employess_with_norm_' + post_code]) {
                record['employess_with_norm_' + post_code].value = Math.round(row.count_workers_correctly*100)/100;
              }
              record['orders_' + post_code] = row.orders
              if (record['number_orders_' + post_code]) {
                 record['number_orders_' + post_code].value = row.load;
              }
              if (record['number_pizzas_' + post_code]) {
                record['number_pizzas_' + post_code].value = row.load
              }
              if (record['proceeds_' + post_code]) {
                record['proceeds_' + post_code].value = row.load
              }
            }

            if (record.isTotalRow) {
              record['corf_' + post_code].value = post.korf.toFixed(2)
              record['load_' + post_code].value = post.kload.toFixed(2)
              record['employees_' + post_code].value = post.count_workers
              record['less_five_' + post_code].value = (post.values[0] === 0) ? '' : post.values[0]
              record['five_to_ten_' + post_code].value = (post.values[1] === 0) ? '' : post.values[1]
              record['more_ten_' + post_code].value = (post.values[2] === 0) ? '' : post.values[2]
             // record['total_' + post_code].value = (post.values[0] + post.values[1] + post.values[2] === 0) ? '' : post.values[0] + post.values[1] + post.values[2]
              if (record['employess_with_norm_' + post_code]) {
                record['employess_with_norm_' + post_code].value = post.count_workers_correctly
              }
            }
          })
        })

        this.tableData.records = this.calculateRecords(this.getTableLatenessCreateCalculation.records)
        //
      })
      this.dataIsLoading = false
    },
    latenessLocalValueTablet(value) {
      if (value !== null) {
        switch (value) {
          case 'operator':
            this.postLocalValues = [{ label: 'Оператор', value: 'operator' }]
            break;
          case 'administrator':
            this.postLocalValues = [{ label: 'Администратор филиала', value: 'administrator' }]
            break;
          case 'suhi':
            this.postLocalValues = [{ label: 'Повар-сушист', value: 'suhi' }]
            break;
          case 'pizzamaker':
            this.postLocalValues = [{ label: 'Повар-пиццемейкер', value: 'pizzamaker' }]
            break;
          case 'hot':
            this.postLocalValues = [{ label: 'Горячий цех', value: 'hot' }]
            break;
          case 'driver':
            this.postLocalValues = [{ label: 'Водитель', value: 'driver' }]
            break;
          default:
            this.postLocalValues = []
        }
      }
    },
    latenessLocalValueMobile(value) {
      if (value !== null) {
        switch (value) {
          case 'operator':
            this.postLocalValues = [{ label: 'Оператор', value: 'operator' }]
            break;
          case 'administrator':
            this.postLocalValues = [{ label: 'Администратор филиала', value: 'administrator' }]
            break;
          case 'suhi':
            this.postLocalValues = [{ label: 'Повар-сушист', value: 'suhi' }]
            break;
          case 'pizzamaker':
            this.postLocalValues = [{ label: 'Повар-пиццемейкер', value: 'pizzamaker' }]
            break;
          case 'hot':
            this.postLocalValues = [{ label: 'Горячий цех', value: 'hot' }]
            break;
          case 'driver':
            this.postLocalValues = [{ label: 'Водитель', value: 'driver' }]
            break;
          default:
            this.postLocalValues = []
        }
      }
    },
    postLocalValues(value) {
      let latenessShortNamesColumns = []

      if (this.latenessLocalValue !== null) {
        latenessShortNamesColumns = ['less_five', 'five_to_ten', 'more_ten']
        let c = latenessShortNamesColumns.findIndex((latenessCol) => latenessCol === this.latenessLocalValue.value)
        if (c !== -1) latenessShortNamesColumns.splice(c, 1)
      }

      if (value.length > 0) {
        let visibleColumns = []

        let totalColIndex = this.getTableLatenessCreateCalculation.columns.findIndex((col) => col.id === 'total')
        if (totalColIndex !== -1) visibleColumns.push(this.getTableLatenessCreateCalculation.columns[totalColIndex])

        value.map((post) => {
          visibleColumns = visibleColumns.concat(this.getTableLatenessCreateCalculation.columns.filter((col) => {
            if (latenessShortNamesColumns.length > 0) {
              let shortColumnName = col.id.split('_').slice(0, -1).join('_')
              if (latenessShortNamesColumns.includes(shortColumnName)) {
                return false
              }
            }

            if (col.id === post.value ||
              col.parentColumnId === post.value) {
              return true
            }

            return false
          }))
        })

        if (value.length > 1) {
          this.getTableLatenessCreateCalculation.columns.map((col) => {
            if (latenessShortNamesColumns.length > 0) {
              let shortColumnName = col.id.split('_').slice(0, -1).join('_')
              if (!latenessShortNamesColumns.includes(shortColumnName) && (col.id === 'inTotal' || col.parentColumnId === 'inTotal')) {
                visibleColumns.push(col)
              }
            } else if (col.id === 'inTotal' || col.parentColumnId === 'inTotal') {
              visibleColumns.push(col)
            }
          })
        }

        this.tableData.columns = [...visibleColumns]
      } else {
        if (latenessShortNamesColumns.length > 0) {
          this.tableData.columns = this.getTableLatenessCreateCalculation.columns.filter((col) => {
            let shortColumnName = col.id.split('_').slice(0, -1).join('_')

            if (!latenessShortNamesColumns.includes(shortColumnName)) {
              return true
            }
            return false
          })
        } else {
          this.tableData.columns = this.getTableLatenessCreateCalculation.columns
        }
      }

      this.tableData.records = this.calculateRecords(this.getTableLatenessCreateCalculation.records)
    },
    latenessLocalValue(value) {
      if (value !== null) {
        let latenessShortNamesColumns = ['less_five', 'five_to_ten', 'more_ten']
        let c = latenessShortNamesColumns.findIndex((latenessCol) => latenessCol === value.value)
        if (c !== -1) latenessShortNamesColumns.splice(c, 1)

        let visibleColumns = []

        if (this.postLocalValues.length > 0) {
          let totalColIndex = this.getTableLatenessCreateCalculation.columns.findIndex((col) => col.id === 'total')
          if (totalColIndex !== -1) visibleColumns.push(this.getTableLatenessCreateCalculation.columns[totalColIndex])

          this.postLocalValues.map((post) => {
            visibleColumns = visibleColumns.concat(this.getTableLatenessCreateCalculation.columns.filter((col) => {
              if (latenessShortNamesColumns.length > 0) {
                let shortColumnName = col.id.split('_').slice(0, -1).join('_')
                if (latenessShortNamesColumns.includes(shortColumnName)) {
                  return false
                }
              }

              if (col.id === post.value ||
                col.parentColumnId === post.value) {
                return true
              }

              return false
            }))
          })

          if (this.postLocalValues.length > 1) {
            this.getTableLatenessCreateCalculation.columns.map((col) => {
              if (latenessShortNamesColumns.length > 0) {
                let shortColumnName = col.id.split('_').slice(0, -1).join('_')
                if (!latenessShortNamesColumns.includes(shortColumnName) && (col.id === 'inTotal' || col.parentColumnId === 'inTotal')) {
                  visibleColumns.push(col)
                }
              } else if (col.id === 'inTotal' || col.parentColumnId === 'inTotal') {
                visibleColumns.push(col)
              }
            })
          }
        } else {
          visibleColumns = this.getTableLatenessCreateCalculation.columns.filter((col) => {
            let shortColumnName = col.id.split('_').slice(0, -1).join('_')

            if (!latenessShortNamesColumns.includes(shortColumnName)) {
              return true
            }
            return false
          })
        }

        this.tableData.columns = [...visibleColumns]
      } else {
        if (this.postLocalValues.length > 0) {
          let visibleColumns = []

          let totalColIndex = this.getTableLatenessCreateCalculation.columns.findIndex((col) => col.id === 'total')
          if (totalColIndex !== -1) visibleColumns.push(this.getTableLatenessCreateCalculation.columns[totalColIndex])

          this.postLocalValues.map((post) => {
            visibleColumns = visibleColumns.concat(this.getTableLatenessCreateCalculation.columns.filter((col) => {

              if (col.id === post.value ||
                col.parentColumnId === post.value) {
                return true
              }

              return false
            }))
          })

          if (this.postLocalValues.length > 1) {
            this.getTableLatenessCreateCalculation.columns.map((col) => {
              if (col.id === 'inTotal' || col.parentColumnId === 'inTotal') {
                visibleColumns.push(col)
              }
            })
          }

          this.tableData.columns = [...visibleColumns]
        } else {
          this.tableData.columns = this.getTableLatenessCreateCalculation.columns
        }
      }

      this.tableData.records = this.calculateRecords(this.getTableLatenessCreateCalculation.records)
    }
  },

  methods: {
    salmon(v){},
    loadvalue(v){},
    collectCalculation() {},

    calculateRecords(records) {
      let totals = []
      let result = records.map((record) => {
        record['less_five_inTotal'].value = 0
        record['five_to_ten_inTotal'].value = 0
        record['more_ten_inTotal'].value = 0
        record['orders_inTotal'] = [[],[],[]];

        for (const [columnName, columnValue] of Object.entries(record)) {
         if (columnName!="orders_inTotal" && columnName.indexOf("orders")==0) {
           for (var i=0; i<columnValue.length; i++){
             for (var j=0; j<columnValue[i].length; j++){
               record['orders_inTotal'][i].push(columnValue[i][j]);
             }
           }
          // console.log(columnName, columnValue);
         }
          if (record.isTotalRow && columnName !== 'isShowRow' && columnName !== 'isTotalRow' && columnName !== 'total') {
            record[columnName].value = 0
          }

          let c = totals.findIndex((total) => total.columnName === columnName)
          if (c === -1 && !record.isTotalRow && columnName !== 'total' && columnName !== 'isShowRow' && columnValue.value) {
            totals.push({
              columnName,
              amount: Number(columnValue.value)
            })
          } else if (c !== -1) {
            totals[c].amount += Number(columnValue.value)
          }

          let latenessShortNamesColumns = ['less_five', 'five_to_ten', 'more_ten']
          let parentColumnName = columnName.split('_').pop()
          let shortColumnName = columnName.split('_').slice(0, -1).join('_')
          let findIndexCol = this.tableData.columns.findIndex((col) => col.id === columnName)

          if (findIndexCol !== -1) {
            latenessShortNamesColumns.map((latenessCol) => {
              if (shortColumnName === latenessCol && parentColumnName !== 'inTotal') {
                record[shortColumnName + '_inTotal'].value += Number(columnValue.value)
              }
            })
          }

          if (record.isTotalRow && columnName !== 'total') {
            let b = totals.findIndex((total) => total.columnName === columnName)
            if (b !== -1) {
              if (Number.isInteger(totals[b].amount)) {
                record[columnName].value = Number(totals[b].amount)
              } else {
                record[columnName].value = Number(totals[b].amount).toFixed(2)
              }
            }
          }
        }

        if (record['less_five_inTotal'].value === 0) {
          record['less_five_inTotal'].value = ''
        }
        if (record['five_to_ten_inTotal'].value === 0) {
          record['five_to_ten_inTotal'].value = ''
        }
        if (record['more_ten_inTotal'].value === 0) {
          record['more_ten_inTotal'].value = ''
        }


        if (record.isTotalRow && this.data && this.data.calc && this.data.calc.delayed && this.data.calc.delayed.posts) {

          this.data.calc.delayed.posts.forEach((p) => {
            var code = p.post_code;
            if (code=="Call-centr") code="operator";
            record['corf_'+code].value = p.korf.toFixed(1);
              record['load_'+code].value = p.kload.toFixed(1);
          })
        }
/*
        if (record.isTotalRow && this.data) {
          record['corf_operator'].value = (record['corf_operator'].value !== 0) ? (record['corf_operator'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['load_operator'].value = (record['load_operator'].value) ? (record['load_operator'].value / this.tableData.records.length - 1).toFixed(2) : 0
          //record['corf_administrator'].value = (record['corf_administrator'].value) ? (record['corf_administrator'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['load_administrator'].value = (record['load_administrator'].value) ? (record['load_administrator'].value / this.tableData.records.length - 1).toFixed(2) : 0
          //record['corf_suhi'].value = (record['corf_suhi'].value) ? (record['corf_suhi'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['load_suhi'].value = (record['load_suhi'].value) ? (record['load_suhi'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['corf_pizzamaker'].value = (record['corf_pizzamaker'].value) ? (record['corf_pizzamaker'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['load_pizzamaker'].value = (record['load_pizzamaker'].value) ? (record['load_pizzamaker'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['corf_hot'].value = (record['corf_hot'].value) ? (record['corf_hot'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['load_hot'].value = (record['load_hot'].value) ? (record['load_hot'].value / this.tableData.records.length - 1).toFixed(2) : 0
          record['employess_with_norm_suhi'].value = record['employess_with_norm_suhi'].value
          record['employess_with_norm_pizzamaker'].value = record['employess_with_norm_pizzamaker'].value
        }
*/
        record['total_inTotal'].value = Number(record['less_five_inTotal'].value) +
          Number(record['five_to_ten_inTotal'].value) +
          Number(record['more_ten_inTotal'].value)

        if (record['total_inTotal'].value === 0) {
          record['total_inTotal'].value = ''
        }

        return record
      })

      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.lateness {

  &-header {
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    &-posts {
      min-width: 200px;
      max-width: fit-content;
      width: 100%;

      ::v-deep .c-input-value-multiple {
        //flex-wrap: nowrap;
        max-width: initial;
      }

      @media screen and (max-width: 1024px) {
        display: none;
      }

      &-tablet {
        display: none;

        @media screen and (max-width: 1024px) {
          display: block;
        }

        @media screen and (max-width: 768px){
          display: none;
        }

        ::v-deep .c-switcher-group-item {
          padding: 0 10px;
        }
      }

      &-mobile {
        display: none;
        margin-bottom: 26px;

        ::v-deep .c-switcher-group-item {
          width: 46.5px;
        }

        @media screen and (max-width: 768px) {
          display: block;
        }
      }
    }

    &-lateness {
      max-width: 200px;
      width: 100%;
      margin-left: 20px;

      @media screen and (max-width: 768px) {
        margin-left: 0;
        max-width: 100%;
      }
    }
  }

  &-table {
    margin-top: 20px;

    &-layout-fixed {
      & ::v-deep #tableWithFixedFirstColumn {
        table-layout: fixed;

        @media screen and (max-width: 500px) {
          table-layout: initial;
        }
      }

    }

    @media screen and (max-width: 700px) {
      margin-bottom: 47px;
    }

    ::v-deep .c-table__column-wrapper {
      justify-content: center;
    }

    ::v-deep #c-table-column-total .c-table__column-wrapper {
      justify-content: flex-start;
    }

    ::v-deep #tableWithFixedFirstColumn {
      min-width: 100%;
    }

    ::v-deep #c-table-column-five_to_ten_operator .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_administrator .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_suhi .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_pizzamaker .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_hot .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_driver .c-table__column-wrapper,
    ::v-deep #c-table-column-five_to_ten_inTotal .c-table__column-wrapper {
      white-space: nowrap;
    }

    ::v-deep .c-table__header-row:last-child th {
      border-left-style: hidden;
      text-align: center;
    }
    ::v-deep .c-table__cell {
      border-left-style: hidden;
    }
    ::v-deep #c-table-column-administrator,
    ::v-deep #c-table-column-suhi,
    ::v-deep #c-table-column-pizzamaker,
    ::v-deep #c-table-column-hot,
    ::v-deep #c-table-column-driver,
    ::v-deep #c-table-column-inTotal {
      border-left: solid 2px #DFE4EF;
    }

    ::v-deep #c-table-column-corf_administrator,
    ::v-deep #c-table-column-corf_suhi,
    ::v-deep #c-table-column-corf_pizzamaker,
    ::v-deep #c-table-column-corf_hot,
    ::v-deep #c-table-column-corf_driver,
    ::v-deep #c-table-column-corf_inTotal {
      border-left: 2px solid #DFE4EF !important;
    }
    ::v-deep .c-table__cell_total,
    ::v-deep .c-table__cell_corf_administrator,
    ::v-deep .c-table__cell_corf_suhi,
    ::v-deep .c-table__cell_corf_pizzamaker,
    ::v-deep .c-table__cell_corf_hot,
    ::v-deep .c-table__cell_corf_driver {
      border-left: 2px solid #DFE4EF !important;
    }
    ::v-deep #c-table-column-operator .c-table__column-label,
    ::v-deep #c-table-column-administrator .c-table__column-label,
    ::v-deep #c-table-column-suhi .c-table__column-label,
    ::v-deep #c-table-column-pizzamaker .c-table__column-label,
    ::v-deep #c-table-column-hot .c-table__column-label,
    ::v-deep #c-table-column-driver .c-table__column-label,
    ::v-deep #c-table-column-inTotal .c-table__column-label {
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      color: #000000;
    }
    ::v-deep #c-table-column-employess_with_norm_suhi .c-table__column-wrapper,
    ::v-deep #c-table-column-employess_with_norm_pizzamaker .c-table__column-wrapper {
      padding: 8.5px 6px;
    }
    ::v-deep #c-table-column-operator .c-table__column-wrapper,
    ::v-deep #c-table-column-administrator .c-table__column-wrapper,
    ::v-deep #c-table-column-suhi .c-table__column-wrapper,
    ::v-deep #c-table-column-pizzamaker .c-table__column-wrapper,
    ::v-deep #c-table-column-hot .c-table__column-wrapper,
    ::v-deep #c-table-column-driver .c-table__column-wrapper,
    ::v-deep #c-table-column-inTotal .c-table__column-wrapper {
      padding: 13px 8px;
    }
    ::v-deep #c-table-column-number_orders_operator .c-table__column-wrapper,
    ::v-deep #c-table-column-number_orders_administrator .c-table__column-wrapper,
    ::v-deep #c-table-column-number_pizzas_pizzamaker .c-table__column-wrapper,
    ::v-deep #c-table-column-number_orders_driver .c-table__column-wrapper {
      padding: 8.5px 10px;
    }

    ::v-deep .c-table__cell_total .c-table__cell-value {
      text-align: left;
    }
  }

  &-loader {
    margin-top: 20px;
  }

  &-buttons {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media screen and (max-width: 700px) {
      box-shadow: 0px 0px 15px rgba(8, 20, 45, 0.3);
      width: 100%;
      z-index: 100;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-cancel {
      margin-right: 15px;
      background: #FFFFFF;

      @media screen and (max-width: 700px){
        margin-right: 0;
        border-radius: 0;
        width: 50%;
      }
    }

    &-save {
      @media screen and (max-width: 700px){
        border-radius: 0;
        width: 50%;
      }
    }
  }

  &-buttons-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 40px;
    gap: 10px;

    .lateness-buttons {
      margin-top: 0;
    }
  }

  &-toggle-closed--active {
    background-color: #fff !important;
    border-color: #f56c6c !important;
    color: #f56c6c !important;

    &:hover {
      border-color: #e04040 !important;
      color: #e04040 !important;
    }
  }

  &-closed-badge {
    display: inline-block;
    padding: 6px 14px;
    border-radius: 4px;
    background-color: #f56c6c;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
  }
}
</style>